import {create} from 'zustand';
import {ProfessionalDataType} from 'domain/usecases';
import {UseProfessionalDataStoreProps} from './types';

export const useProfessionalDataStore = create<UseProfessionalDataStoreProps>(set => ({
	data: {} as ProfessionalDataType,
	setData: data => set({data}),
	resetData: () => set({data: {} as ProfessionalDataType}),
}));
